import React, { useState } from 'react';
import { useFeatureIsOn, useGrowthBook } from '@growthbook/growthbook-react';
import { FeatureFlags } from '../../constants/featureFlags';
import { useApiConfig } from '../../services/apiConfig';
import logger from '../../utils/logger';
/**
 * Development debug panel for GrowthBook
 * Only shown in development mode
 */
export const GrowthBookDebug = () => {
  const [isOpen, setIsOpen] = useState(false);
  const growthbook = useGrowthBook();
  const apiConfig = useApiConfig();
  const debugEnabled = useFeatureIsOn(FeatureFlags.ENABLE_ADMIN_PANEL_FEATURE_FLAG_DEBUG);

  // Don't render in production
  if (import.meta.env.MODE === 'production' && !debugEnabled) {
    return null;
  }

  const migrationStatus = apiConfig.getMigrationStatus();

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 9999,
      fontFamily: 'monospace'
    }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '8px 12px',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        🚀 GB Debug
      </button>
      
      {isOpen && (
        <div style={{
          position: 'absolute',
          bottom: '40px',
          right: '0',
          background: 'white',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '16px',
          minWidth: '300px',
          maxHeight: '400px',
          overflow: 'auto',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <h3>GrowthBook Debug Panel</h3>
          
          <div>
            <strong>Migration Status:</strong>
            <div>V2 Progress: {migrationStatus.percentage}%</div>
            <div>V2 Resources: {migrationStatus.v2Count}/{migrationStatus.total}</div>
            <div>Global Override: {migrationStatus.globalOverride ? '🔴 ON' : '🟢 OFF'}</div>
          </div>
          
          <hr />
          
          <div>
            <strong>Feature Flags:</strong>
            {Object.entries(FeatureFlags).map(([key, value]) => (
              <div key={key} style={{ fontSize: '12px', margin: '2px 0' }}>
                {key}: {useFeatureIsOn(value) ? '🟢' : '🔴'}
              </div>
            ))}
          </div>
          
          <hr />
          
          <div>
            <strong>User Attributes:</strong>
            <pre style={{ fontSize: '10px', background: '#f5f5f5', padding: '8px' }}>
              {JSON.stringify(growthbook.getAttributes(), null, 2)}
            </pre>
          </div>
          
          <button
            onClick={() => {
              growthbook.loadFeatures();
              logger.log('GrowthBook features refreshed');
            }}
            style={{
              background: '#28a745',
              color: 'white',
              border: 'none',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '8px'
            }}
          >
            Refresh Features
          </button>
        </div>
      )}
    </div>
  );
};

export default GrowthBookDebug;